import {
    START_API_CALL,
    API_CALL_SUCCEEDED,
    API_CALL_FAILED,
    START_RETRIABLE_GET,
    RETRIABLE_GET_COMPLETE,
    CLEAR_APP_ERROR,
    CLEAR_SCREEN_ERROR,
    AUDIO_SAVING_ERROR,
    CLEAR_AUDIO_SAVING_ERROR,
    RETRIABLE_GET_FAILED,
    START_BACKGROUND_RETRY,
    STOP_BACKGROUND_RETRY,
    SET_BACKGROUND_RETRY_ID,
} from './apiCallActions';

import { RETRIABLE_ERRORS } from '../../constants/error';
import { getIsRetriableGetInProgress }  from './apiSelectors';
import { HTTP_RESPONSE_CODE } from '../../constants/http';
import { isAudioSavingRequest } from './apiUtils';

export const defaultState = {
    screenLevelErrorStatus: undefined,
    appLevelErrorStatus: undefined,
    retriableGetInProgress: [],
    retryGetRequestActionName: undefined,
    audioSavingErrorStatus: undefined,
    isBackgroundRetryInProgress: false,
    // TODO: make it a map if you want to support more than 1 background retry at a time
    backgroundRetryId: undefined,
};

const isAppLevelError = (errorStatus) => !RETRIABLE_ERRORS.includes(errorStatus);

const apiReducer = (state = defaultState, action) => {
    const { appLevelErrorStatus } = action;
    switch (action.type) {
    case START_API_CALL:
        if (isAudioSavingRequest(action)) {
            return {
                ...state,
                audioSavingErrorStatus: undefined,
            };
        }
        return {
            ...state,
            screenLevelErrorStatus: undefined,
            appLevelErrorStatus: undefined,
        };
    case API_CALL_SUCCEEDED:
        if (isAudioSavingRequest(action)) {
            return {
                ...state,
                audioSavingErrorStatus: undefined,
            };
        }
        if (getIsRetriableGetInProgress(state)) {
            return state;
        }
        return {
            ...state,
            screenLevelErrorStatus: undefined,
            appLevelErrorStatus: undefined,
        };
    case API_CALL_FAILED:
        if (isAudioSavingRequest(action) && appLevelErrorStatus !== HTTP_RESPONSE_CODE.UNAUTHORIZED) {
            return {
                ...state,
                audioSavingErrorStatus: appLevelErrorStatus,
            };
        }
        if (isAppLevelError(appLevelErrorStatus) || getIsRetriableGetInProgress(state)) {
            return {
                ...state,
                screenLevelErrorStatus: undefined,
                appLevelErrorStatus,
            };
        }

        return {
            ...state,
            screenLevelErrorStatus: appLevelErrorStatus,
            appLevelErrorStatus: undefined,
        };
    case START_RETRIABLE_GET: {
        if (state.retriableGetInProgress.includes(action.retryGetRequestActionName)) {
            return state;
        }
        return {
            ...state,
            retriableGetInProgress: [
                ...state.retriableGetInProgress,
                action.retryGetRequestActionName],
        };
    }
    case RETRIABLE_GET_COMPLETE:
        return {
            ...state,
            retriableGetInProgress: state.retriableGetInProgress
                .filter((actionName) => actionName !== action.retryGetRequestActionName),
            retryGetRequestActionName:
                (state.retryGetRequestActionName === action.retryGetRequestActionName)
                    ? undefined : state.retryGetRequestActionName,
        };
    case RETRIABLE_GET_FAILED: {
        if (!state.retriableGetInProgress.includes(action.retryGetRequestActionName)) {
            return state;
        }
        return {
            ...state,
            retryGetRequestActionName: action.retryGetRequestActionName,
        };
    }
    case CLEAR_APP_ERROR:
        return {
            ...state,
            appLevelErrorStatus: undefined,
        };
    case CLEAR_SCREEN_ERROR:
        return {
            ...state,
            screenLevelErrorStatus: undefined,
        };
    case START_BACKGROUND_RETRY:
        return {
            ...state,
            isBackgroundRetryInProgress: true,
        };
    case STOP_BACKGROUND_RETRY:
        return {
            ...state,
            isBackgroundRetryInProgress: false,
            backgroundRetryId: undefined,
        };
    case SET_BACKGROUND_RETRY_ID:
        return {
            ...state,
            backgroundRetryId: action.id,
        };
    case AUDIO_SAVING_ERROR:
        return {
            ...state,
            audioSavingErrorStatus: action.statusCode,
        };
    case CLEAR_AUDIO_SAVING_ERROR:
        return {
            ...state,
            audioSavingErrorStatus: undefined,
        };
    default:
        return state;
    }
};

export default apiReducer;
